import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/users")({
  component: () => (
    <>
      <div className="page-header">
        <div className="page-title">Users</div>
        <div className="page-subtitle">Manage all users</div>
      </div>
    </>
  ),
});
